import { useTranslation } from 'react-i18next';
import { Chip } from '@mui/material';

import { PAYMENT_STATUS, PAYMENT_TYPE } from '@/models/payment';
import { formatPrice } from '@/utils';

const statuses = {
	[PAYMENT_STATUS.CANCELED]: {
		textKey: 'canceled'
	},
	[PAYMENT_STATUS.PAID]: {
		textKey: 'paid',
		color: 'success'
	},
	[PAYMENT_STATUS.PENDING]: {
		textKey: 'pending',
		color: 'warning'
	},
	[PAYMENT_TYPE.DISPUTE]: {
		textKey: 'disputed',
		color: 'info'
	},
	[PAYMENT_TYPE.REFUND]: {
		textKey: 'refunded',
		color: 'info'
	},
	[PAYMENT_STATUS.ERROR]: {
		textKey: 'error',
		color: 'error'
	},
	retry: {
		textKey: 'retry',
		color: 'error'
	},
	partiallyRefunded: {
		textKey: 'partiallyRefunded',
		color: 'info'
	}
};

export function PaymentStatusChip({
	type,
	status = null,
	isLastPayment,
	amountRefunded,
	currency,
	hasPayAction
}) {
	const { t } = useTranslation();

	let currentStatus = statuses[status] || {};

	const refunded = type === PAYMENT_TYPE.REFUND;
	const partiallyRefunded = false; // TODO: complete validation
	const disputed = type === PAYMENT_TYPE.DISPUTE;

	const text =
		partiallyRefunded && amountRefunded
			? `(${formatPrice({ amount: amountRefunded, currency })})`
			: '';

	if (type !== PAYMENT_TYPE.PAYMENT) {
		currentStatus = statuses[type];
	}

	if (status === null) {
		currentStatus = {
			textKey: status,
			color: 'info'
		};
	}

	if (hasPayAction && isLastPayment) {
		currentStatus = statuses.retry;
	} else if (hasPayAction && !isLastPayment) {
		currentStatus = statuses[status];
	}

	if (refunded) {
		currentStatus = statuses.refund;
	}

	if (disputed) {
		currentStatus = statuses.dispute;
	}

	if (partiallyRefunded) {
		currentStatus = statuses.partiallyRefunded;
	}

	return (
		<Chip
			color={currentStatus.color}
			label={`${t(`billing.paymentStatus.${currentStatus.textKey}`)} ${text}`}
		/>
	);
}
